import axios from "@/libs/api.request";
// 获取批量信息
export const getList = params => {
  return axios.request({
    url: "/user/client/webhookList",
    method: "GET",
    params
  });
};
export const update = data => {
  return axios.request({
    url: `/user/client/setWebhook`,
    method: "POST",
    data
  });
};
